
export const USER_PRESENTATIONS_COLLECTION_NAME = "user-presentations";
export const PRESENTATIONS_COLLECTION_NAME = "presentations";
export const ANSWERS_COLLECTION_NAME = "answers";
